import { IonApp } from '@ionic/react'
import { IonReactRouter } from '@ionic/react-router'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import App from './App'
import { AppContextProvider } from './context/AppContext'
import store from './redux/store'

const container: any = document.getElementById('root')
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <IonApp>
      <IonReactRouter>
        <AppContextProvider>
          <App />
        </AppContextProvider>
      </IonReactRouter>
    </IonApp>
  </Provider>
)
